import React from 'react';
import { withRouter } from 'react-router-dom';
import Loader from '../../component/common/Loader';
import CONSTANT from '../../constant';
import { getUserDetail, formatDateDDMMYY } from '../../utils';
import {
  getEmployeeAuthorityDetail,
  getKpiReport,
} from '../../actions/AppraisalCycleAction';

class SelfAppraisalList extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      detail: null,
      employeeCode: '',
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = 'Self Appraisal - ' + CONSTANT.organisation.name;

    const user = getUserDetail();
    const employeeCode = user?.code || '';
    this.setState({ employeeCode, showLoader: true });

    getEmployeeAuthorityDetail({ employeeCode }).then((res: any) => {
      const detail = res?.result || res || null;
      this.setState({ detail, showLoader: false });
    });
  }

  viewCompletedReport = (row: any) => {
    const { employeeCode, detail } = this.state;
    this.props.history.push({
      pathname: CONSTANT.component.employeeCompletedReport.url,
      state: {
        employeeCode,
        appraisalCycleId: detail?.cycle?.id,
        periodId: row.periodId,
      },
    });
  };

  selectPeriod = (row: any) => {
    const { employeeCode, detail } = this.state;
    const isMouApplicable = detail?.cycle?.is_mou_applicable || false;
    const selectedRecord = { ...row, cycle: detail?.cycle };

    this.setState({ showLoader: true });

    getKpiReport({ appraisalCycleId: detail?.cycle?.id, effectiveFrom: row.startDate, employeeCode, reportType: 'employee' }).then((res: any) => {
      const report = res?.result || null;

      let kpiData: any = {
        kpiReportId: null,
        kpiStatus: null,
        isMouApplicable,
        mouTaskDescription: '',
        mouDeliverables: '',
        mouAchievement: '',
        otherKeyTasks: [],
      };

      if (report) {
        const mouTask = report.tasks?.find((t: any) => t.particular === '*)') || null;
        const otherTasks = report.tasks
          ?.filter((t: any) => t.particular !== '*)')
          .map((t: any) => ({
            id: t.id,
            particular: t.particular,
            taskDescription: t.task_description || '',
            weightage: t.weightage || '',
            deliverables: t.deliverables || '',
            achievement: t.achievement || '',
          }));

        kpiData = {
          kpiReportId: report.id,
          kpiStatus: report.kpi_status || 'draft',
          isMouApplicable,
          mouTaskDescription: mouTask?.task_description || '',
          mouDeliverables: mouTask?.deliverables || '',
          mouAchievement: mouTask?.achievement || '',
          otherKeyTasks: otherTasks || [],
        };
      }

      this.setState({ showLoader: false });

      this.props.history.push({
        pathname: CONSTANT.component.selfAppraisal.url,
        state: {
          selectedRecord,
          employeeCode,
          ...kpiData,
        },
      });
    });
  };

  render() {
    const { showLoader, detail } = this.state;

    const rows: any[] = [];
    if (detail) {
      const cycle = detail.cycle || {};
      const cycleName = cycle.cycle_name || cycle.financial_year || `Cycle ${cycle.id}`;
      const financialYear = cycle.financial_year || '-';
      rows.push({
        key: `orig-${cycle.id}`, cycleName, financialYear,
        startDate: detail.startDate,
        endDate: detail.endDate,
        periodType: 'Original', isOriginal: true,
        periodStatus: detail.status || 'Draft',
        saSubmitted: detail.saSubmitted || false,
        reportingManagerName: detail.reportingManagerName || null,
        reviewingManagerName: detail.reviewingManagerName || null,
        acceptingAuthorityName: detail.acceptingAuthorityName || null,
        periodId: detail.periodId || null,
      });

      (detail.transferList || []).forEach((t: any, idx: number) => {
        rows.push({
          key: `transfer-${idx}`, cycleName, financialYear,
          startDate: t.startDate,
          endDate: t.endDate,
          periodType: `Period #${idx + 1}`, isOriginal: false,
          periodStatus: t.status || 'Draft',
          saSubmitted: t.saSubmitted || false,
          reportingManagerName: t.reportingManagerName || null,
          reviewingManagerName: t.reviewingManagerName || null,
          acceptingAuthorityName: t.acceptingAuthorityName || null,
          periodId: t.periodId || null,
        });
      });
    }

    return (
      <div className="container-fluid mb-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card homedob">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Self Appraisal</h1>
                  <p className="text-muted">Select the appraisal period to fill your self appraisal.</p>
                </div>
              </div>
              {showLoader && <Loader />}
              {!showLoader && rows.length === 0 && (
                <div className="alert alert-warning mt-3">No appraisal periods found for your account.</div>
              )}
              {!showLoader && rows.length > 0 && rows.some((row: any) => !row.reportingManagerName || !row.reviewingManagerName || !row.acceptingAuthorityName) && (
                <div className="alert alert-danger mt-3">
                  <i className="fa fa-exclamation-triangle mr-2" />
                  <strong>Managers Not Assigned:</strong> One or more appraisal periods do not have all managers (Reporting, Reviewing, Accepting Authority) assigned. Please contact HR to get managers assigned before filling the appraisal.
                </div>
              )}
              {!showLoader && rows.length > 0 && (
                <div className="row mt-3">
                  <div className="col-md-12">
                    <div className="table-container">
                      <div className="table-wrapper radius-4">
                        <table className="tablen">
                          <thead>
                            <tr className="text-center">
                              <th className="table-dark">#</th>
                              <th className="table-dark">Cycle</th>
                              <th className="table-dark">Financial Year</th>
                              <th className="table-dark">Period</th>
                              {/* <th className="table-dark">Type</th> */}
                              <th className="table-dark">Reporting Manager</th>
                              <th className="table-dark">Reviewing Manager</th>
                              <th className="table-dark">Accepting Authority</th>
                              <th className="table-dark">Status</th>
                              <th className="table-dark">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rows.map((row: any, idx: number) => (
                              <tr key={row.key} className="text-center">
                                <td>{idx + 1}</td>
                                <td>{row.cycleName}</td>
                                <td>{row.financialYear}</td>
                                <td>{formatDateDDMMYY(row.startDate)}{row.endDate ? ` to ${formatDateDDMMYY(row.endDate)}` : ' onwards'}</td>
                                {/* <td>
                                  <span className={`badge ${row.isOriginal ? 'badge-success' : 'badge-warning'}`}>
                                    {row.periodType}
                                  </span>
                                </td> */}
                                <td>{row.reportingManagerName || <span className="text-danger small">Not Assigned</span>}</td>
                                <td>{row.reviewingManagerName || <span className="text-danger small">Not Assigned</span>}</td>
                                <td>{row.acceptingAuthorityName || <span className="text-danger small">Not Assigned</span>}</td>
                                <td>
                                  <span className={`badge ${row.periodStatus === 'Active' ? 'badge-success' : row.periodStatus === 'Completed' ? 'badge-secondary' : 'badge-warning'}`}>
                                    {row.periodStatus}
                                  </span>
                                </td>
                                <td>
                                  {row.reportingManagerName && row.reviewingManagerName && row.acceptingAuthorityName ? (
                                    <button
                                      className="btn btn-sm submit-button"
                                      onClick={() => row.periodStatus === 'Completed' ? this.viewCompletedReport(row) : this.selectPeriod(row)}
                                    >
                                      <i className={`fa ${row.periodStatus === 'Completed' ? 'fa-eye' : row.saSubmitted ? 'fa-check' : 'fa-pencil'} mr-1`} />
                                      {row.saSubmitted ? 'Submitted' : row.periodStatus === 'Completed' ? 'View Report' : 'Fill Appraisal'}
                                    </button>
                                  ) : (
                                    <span className="text-danger small font-weight-bold">
                                      <i className="fa fa-exclamation-circle mr-1" />
                                      Managers Not Assigned
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SelfAppraisalList);
